require('datatables.net-bs4');

$(document).ready(function() {
  if($('[id^=contacts_datatable_wrapper]').length == 0 && $('#contacts_datatable').length > 0) {
    table = $('#contacts_datatable').DataTable({
      dom: "<'row'<'col-6'l><'#contact_btn_add_page.col-6 text-right'>>" +
        "<'row'<'#contact_btn_batch_delete.col-sm-12'>>" +
        "<'row'<'col-sm-12'tr>>" +
        "<'float-right mb-3'p>",
      pagingType: 'full_numbers',
      lengthMenu: [[10, 20, 50], ["10件", "20件", "50件"]],
      language: {
        lengthMenu: "_MENU_ を表示する",
        paginate: {
          first: '<< 最初へ',
          last: '最後へ >>',
          next: '次へ >',
          previous: '< 前へ',
        },
        emptyTable: "お問い合わせフォームは登録されておりません"
      },
      order: [[ 1, 'asc' ]],
      columnDefs: [
        {
          targets: 0,
          orderable: false,
        },
        {
          targets: 2,
          orderable: false,
        },
        {
          targets: 3,
          orderable: false,
        }
      ],
      drawCallback: function(settings) {
        var pagination = $(this).closest('.dataTables_wrapper').find('.dataTables_paginate');
        pagination.toggle(this.api().page.info().pages > 1);

        String(localStorage.getItem('checked_contacts')).split(',').forEach(function(value) {
          $('.checkbox_contact[value=' + value + ']').prop('checked', true);
        });

        number_of_checkbox_enable = $('.checkbox_contact').not(':disabled').length;
        number_of_checkbox_unchecked = $('.checkbox_contact:not(:checked)').not(':disabled').length;

        if (number_of_checkbox_enable == 0 || number_of_checkbox_unchecked > 0) {
          $('#contact_checkbox_check_all').prop('checked', false);
        } else {
          $('#contact_checkbox_check_all').prop('checked', true);
        }
      },
      stateSave: true
    });

    $('#contact_btn_add_page').append(`<a href='${$('#contacts_datatable').data("add-new-link")}' class='btn btn-info'>新規追加</a>`);
    $('#contact_btn_batch_delete').append("<input type='submit' id='contact_batch_delete_contact_btn' value='一括削除' class='btn btn-info my-3' data-confirm='削除後のデータは復旧できません。よろしいですか？' data-disable-with='一括削除' />");
  } else {
    localStorage.removeItem('checked_contacts')
  }

  $('#contact_checkbox_check_all').on('click', function() {
    if (this.checked) {
      $('.checkbox_contact').not(':disabled').prop('checked', true);
    } else {
      $('.checkbox_contact').not(':disabled').prop('checked', false);
    }
    $('.checkbox_contact').first().trigger('change');
  });

  $('#contacts_datatable').on('click', '.checkbox_contact', function() {
    number_of_checkbox_unchecked = $('.checkbox_contact:checkbox:not(:checked)').not(':disabled').length;
    if (number_of_checkbox_unchecked > 0) {
      $('#contact_checkbox_check_all').prop('checked', false);
    } else {
      $('#contact_checkbox_check_all').prop('checked', true);
    }
  });

  $('#contact_batch_delete_contact_btn').on('click', function(event) {
    if ($('.checkbox_contact:checked').not(':disabled').length == 0) {
      event.preventDefault();
      alert('チェックボックスが選択されていません');
      return false;
    } else {
      let deleteItem = []
      $('.checkbox_contact:checked').each(function() {
        deleteItem.push($(this).val());
      });
      $('#contacts_delete').val(deleteItem);
    }
  });

  $('.checkbox_contact').on('change', function() {
    var checked_contacts = String(localStorage.getItem('checked_contacts')).split(',');

    $('.checkbox_contact').each(function() {
      var index = checked_contacts.indexOf($(this).val());
      if (index !== -1) checked_contacts.splice(index, 1);
    });

    $('.checkbox_contact:checked').each(function() {
      checked_contacts.push($(this).val());
    });

    localStorage.setItem('checked_contacts', checked_contacts.join(','));
  })
});
